import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import axios from 'axios'
import sanitizeHtml from 'sanitize-html'
import '@fortawesome/fontawesome-pro/css/all.min.css'
import 'vue2-animate/dist/vue2-animate.min.css'
import 'froala-editor/css/froala_style.css'

import AudioPlayer from './components/AudioPlayer'
import PlotFactoryBranding from './components/PlotFactoryBranding'
import './plugins/vuetify'
import App from './App.vue'
import createRouter from './router'
import createStore from './store'
import './style.scss'

Vue.config.productionTip = false

Vue.prototype.$sanitize = sanitizeHtml

Vue.prototype.$bus = window.Bus = new Vue()

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

Vue.component('audio-player', AudioPlayer)
Vue.component('plot-factory-branding', PlotFactoryBranding)

axios.get(`/stories/preview/${window.__uuid === '{uuid}' ? 'uuid' : window.__uuid}`).then(({data}) => {
    data.preview.options = data.preview.options || {}
    let store = createStore(data)
    let router = createRouter(data)

    if (process.env.NODE_ENV === 'production') {
        Vue.use(VueAnalytics, {
            id: 'UA-102297952-1',
            router,
        })
    }

    window.vm = new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
})
